(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-menu-two-column"] && !Shopify.designMode) return;
  try {
    class MobileMenuTwoColumn extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll("[data-mobile-menu-tab]"));
      this.panels = Array.from(this.querySelectorAll("[data-mobile-menu-panel]"));
      this.activeIndex = this.tabs.findIndex((tab) => tab.classList.contains("is-active"));
      if (this.activeIndex < 0) this.activeIndex = 0;

      this.tabs.forEach((tab) => {
        tab.addEventListener("click", (event) => {
          event.preventDefault();
          this.activate(Number(tab.dataset.mobileMenuTab));
        });
      });

      this.bodyObserver = new MutationObserver(() => this.syncTabindex());
      this.bodyObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ["class"],
      });

      this.activate(this.activeIndex);
      this.syncTabindex();
    }

    disconnectedCallback() {
      if (this.bodyObserver) this.bodyObserver.disconnect();
    }

    isDrawerOpen() {
      return document.body.classList.contains("menu-open");
    }

    activate(index) {
      this.activeIndex = index;
      this.tabs.forEach((tab) => {
        const isActive = Number(tab.dataset.mobileMenuTab) === index;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      this.panels.forEach((panel) => {
        const isActive = Number(panel.dataset.mobileMenuPanel) === index;
        panel.classList.toggle("is-active", isActive);
        panel.hidden = !isActive;
      });

      this.syncTabindex();
    }

    syncTabindex() {
      const open = this.isDrawerOpen();
      this.tabs.forEach((tab) => tab.setAttribute("tabindex", open ? "0" : "-1"));
      this.panels.forEach((panel) => {
        const active = panel.classList.contains("is-active");
        panel.querySelectorAll("a").forEach((link) => {
          link.setAttribute("tabindex", open && active ? "0" : "-1");
        });
      });
    }
  }

  if (!customElements.get("mobile-menu-two-column")) {
    customElements.define("mobile-menu-two-column", MobileMenuTwoColumn);
  }
  } catch(e) { console.error(e); }
})();

})();
